<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()&&showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期编号">
          <el-input size="mini" v-model="params.TermNumber" placeholder="请填写学期编号" clearable />
        </el-form-item>
        <el-form-item label="学期名称">
          <el-input size="mini" v-model="params.TermName" placeholder="请填写学期名称" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TermNumber" label="学期编号" min-width="100" />
        <el-table-column prop="TermName" label="学期名称" min-width="140"  />
        <el-table-column prop="StartTime" label="开始时间" min-width="100" >
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.StartTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EndTime" label="结束时间" min-width="100" >
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.EndTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" min-width="100" >
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require("@/api/ed/term").default,
      params: {
        TermName: "",
        TermNumber: "",
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>